import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import { CaretRightOutlined, CaretLeftOutlined } from '@ant-design/icons'
import dynamic from 'next/dynamic';
import $ from 'jquery';
import ProgressLoading from '@/componentWebs/vietnamTickets/ProgressLoading';
import { stringify } from 'qs';

const OwlCarousel = dynamic(() => import(`@/componentWebs/Global/OwlCarousel`), {
  ssr: false,
  loading: () => null,
});

const pageSize = 65;

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataProvinces: [],
      isInternational: props.isInternational || '0',
      key: Math.random(),
      typesId: props.typesId || '2',
    };
  }

  componentDidMount() {
    this.fetch();
  }

  // componentWillReceiveProps(nextProps) {
  //   const { isInternational } = this.props;
  //   if (nextProps.isInternational !== isInternational) {
  //     this.setState(
  //       {
  //         isInternational: nextProps.isInternational,
  //         // key: `${Math.random()}_${nextProps.isInternational}`,
  //         key: nextProps.isInternational,
  //       },
  //       () => {
  //         this.fetch();
  //       }
  //     );
  //   }
  // }

  fetch = () => {
    const { dispatch } = this.props;
    const { isInternational, typesId } = this.state;

    dispatch({
      type: 'webs/fetchAutoComplete',
      payload: {
        filter: {
          isInternational,
          typesId,
        },
        // sort: ['countrieName', 'asc'],
        range: [0, pageSize - 1],
        // attributes: `id,countrieName`,
      },
      callback: res => {
        if (res.success) {
          this.setState({
            dataProvinces: (res && res.result && res.result.list) || [],
          });
        }
      },
    });
  };

  handleClickProvince = item => {
    const { typesId } = this.state;
    const params = {
      travelTourDestinationLocations: [item.countries && item.countries.id, item.id],
      diemDenText: `${item.provinceName}, ${item.countries && item.countries.countrieName}`,
      textProvinces: item.provinceName,
    };

    switch (typesId) {
      case '4': {
        window.location.href = `/searchTour?${stringify(params)}`;
        break;
      }

      case '5': {
        window.location.href = `/searchCombo?${stringify(params)}`;
        break;
      }
      case '2': {
        const paramhotel = {
          diaDiem: [item.countries && item.countries.id, item.id],
          diemDenText: `${item.provinceName}, ${item.countries && item.countries.countrieName}`,
          textProvinces: item.provinceName,
        };
        window.location.href = `/searchHotel?${stringify(paramhotel)}`;
        break;
      }

      default:
        break;
    }
  };

  render() {
    const { dataAd } = this.props;
    const { dataProvinces, key, typesId } = this.state;
    let obj = 'totalHotels';

    switch (typesId) {
      case '4': {
        obj = 'totalTours';
        break;
      }

      case '5': {
        obj = 'totalTours';
        break;
      }

      default:
        break;
    }

    const imageResize = [
      {
        desktop: {
          width: 85
        }
      },
      {
        tablet: {
          width: 85
        }
      },
      {
        mobile: {
          width: 85
        }
      }
    ]
    return (
      <div className="khachSan__diadiem">
        {dataProvinces && dataProvinces.length > 0 && (
          <div className="box-provinces-list">
            <OwlCarousel
              className="owl-carousel"
              dots={false}
              slideBy={1}
              // key={key}
              responsive={{
                0: {
                  nav: false,
                  items: 3,
                  margin: 15,
                },
                376: {
                  nav: false,
                  items: 4,
                  margin: 20,
                },
                425: {
                  nav: false,
                  items: 3,
                  margin: 25,
                },
                768: {
                  nav: false,
                  items: 8,
                  margin: 25,
                },
                1000: {
                  nav: true,
                  items: 8,
                  margin: 25,
                },
              }}
              navText={[
                '<img src="/static/vietnamTickets/images/leftnavigationbutton.png" />',
                '<img src="/static/vietnamTickets/images/rightnavigationbutton.png" />',
              ]}
            // loop
            >
              {dataProvinces.map(item => (
                <div
                  className="box-provinces"
                  key={item.id}
                  onClick={() => this.handleClickProvince(item)}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src={
                      (item.images &&
                        item.images[0] &&
                        item.images[0].file &&
                        getResponsiveImage(item.images[0].file, imageResize)) ||
                      '/static/vietnamTickets/images/unimage.png lazyload'
                    }
                    alt={item.provinceName}
                    className="khachSan__diadiem__img"
                  />
                  <div className="text">{`${item.provinceName} (${item[obj]})`}</div>
                </div>
              ))}
            </OwlCarousel>
          </div>
        )}
      </div>
    );
  }
}

export default Index;
